export default "__VITE_ASSET__DfYGzJM6__"